import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as formActions } from 'react-redux-form';
import { ProfileStep5Component } from './ProfileStep5';
import modalCancelActions from 'actions/modalCancelActions';
import stepsActions from 'actions/stepsActions';
import ibanActions from 'actions/ibanActions';
import documentationActions from 'actions/documentationActions';
import { loanStatus } from 'actions/aresActions';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

const mapStateToProps = state => {
    return {
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        documentation: state.documentation,
        preLoader: state.preLoader,
        promotionalCode: state.promotionalCode,
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(stepsActions, dispatch),
    getLoanStatus: bindActionCreators(loanStatus, dispatch),
    formActions: bindActionCreators(formActions, dispatch),
    documentationActions: bindActionCreators(documentationActions, dispatch),
    modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
    ibanActions: bindActionCreators(ibanActions, dispatch),
});

export const ProfileStep5 = connect(mapStateToProps, mapDispatchToProps)(withFeatureToggling(ProfileStep5Component));
